__webpack_require__.b = document.baseURI || self.location.href;

// object to store loaded and loading chunks
// undefined = chunk not loaded, null = chunk preloaded/prefetched
// Promise = chunk loading, 0 = chunk loaded
var installedChunks = {
	"index": 0
};


// no chunk on demand loading

// no prefetching

// no preloaded

// no HMR

// no HMR manifest

// no deferred startup

// no jsonp function

// no deferred startup